import ConfirmationCancelDialog from './ConfirmationCancelDialog';

export default ConfirmationCancelDialog;
